import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-objects-bind-bug',
  slug: 'bind-bug',
  title: 'The method that lost its object',
  type: 'bug-hunt',
  estSeconds: 420,
  contentVersion: 1,
});
